var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestTrialsStructured(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1818 0V10.5H17.7273V15.75H7.09091C5.12318 15.75 3.54545 17.3075 3.54545 19.25V24.5H0V35H10.6364V24.5H7.09091V19.25H17.7273V24.5H14.1818V35H24.8182V24.5H21.2727V19.25H31.9091V24.5H28.3636V35H39V24.5H35.4545V19.25C35.4545 17.3075 33.8768 15.75 31.9091 15.75H21.2727V10.5H24.8182V0H14.1818Z",
    fill: "url(#paint0_linear_546_23663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_546_23663",
    x1: 19.5,
    y1: 0,
    x2: 19.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTrialsStructured);
export default __webpack_public_path__ + "static/media/Test_&_Trials_Structured.b55fcf8b631043a4ecabf83758d31237.svg";
export { ForwardRef as ReactComponent };